import React from 'react';
import styles from './Footer.module.scss';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.leftCol}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} Rash Digital. All rights reserved.
          </p>
          <div className={styles.links}>
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
        
        
        <div className={styles.attributionCol}>
          <a href="https://mlwink.com" target="_blank" rel="noopener noreferrer" className={styles.developerLink}>
            <span className={styles.label}>Designed & Developed by</span>
            <span className={styles.brand}>MLWiNK <span className={styles.brandTag}>Developers</span></span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
